/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  InvitationCreatedOut,
  ListOwnersParams,
  OwnerIn,
  OwnerOut,
  PaginatedOwnerListOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type inviteOwnerToPortalResponse200 = {
  data: InvitationCreatedOut
  status: 200
}

export type inviteOwnerToPortalResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type inviteOwnerToPortalResponseSuccess = (inviteOwnerToPortalResponse200) & {
  headers: Headers;
};
export type inviteOwnerToPortalResponseError = (inviteOwnerToPortalResponse422) & {
  headers: Headers;
};

export type inviteOwnerToPortalResponse = (inviteOwnerToPortalResponseSuccess | inviteOwnerToPortalResponseError)

export const getInviteOwnerToPortalUrl = (ownerId: number,) => {




  return `/api/owners/${ownerId}/portal-invite`
}

/**
 * @summary Invite Owner To Portal
 */
export const inviteOwnerToPortal = async (ownerId: number, options?: Parameters<typeof apiFetch>[1]): Promise<inviteOwnerToPortalResponse> => {

  return apiFetch<inviteOwnerToPortalResponse>(getInviteOwnerToPortalUrl(ownerId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getInviteOwnerToPortalMutationKey = () => ['inviteOwnerToPortal'] as const;

export const getInviteOwnerToPortalMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOwnerToPortal>>, TError,InviteOwnerToPortalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteOwnerToPortal>>, TError,InviteOwnerToPortalMutationVariables, TContext> => {

const mutationKey = getInviteOwnerToPortalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteOwnerToPortal>>, InviteOwnerToPortalMutationVariables> = (props) => {
          const {ownerId} = props ?? {};

          return  inviteOwnerToPortal(ownerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteOwnerToPortalMutationResult = NonNullable<Awaited<ReturnType<typeof inviteOwnerToPortal>>>

    export type InviteOwnerToPortalMutationError = HTTPValidationError
    export type InviteOwnerToPortalMutationVariables = {ownerId: number}

    /**
 * @summary Invite Owner To Portal
 */
export const useInviteOwnerToPortal = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteOwnerToPortal>>, TError,InviteOwnerToPortalMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteOwnerToPortal>>,
        TError,
        InviteOwnerToPortalMutationVariables,
        TContext
      > => {
      return useMutation(getInviteOwnerToPortalMutationOptions(options), queryClient);
    }
    export type removeOwnerPortalAccessResponse204 = {
  data: void
  status: 204
}

export type removeOwnerPortalAccessResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeOwnerPortalAccessResponseSuccess = (removeOwnerPortalAccessResponse204) & {
  headers: Headers;
};
export type removeOwnerPortalAccessResponseError = (removeOwnerPortalAccessResponse422) & {
  headers: Headers;
};

export type removeOwnerPortalAccessResponse = (removeOwnerPortalAccessResponseSuccess | removeOwnerPortalAccessResponseError)

export const getRemoveOwnerPortalAccessUrl = (ownerId: number,) => {




  return `/api/owners/${ownerId}/portal-access`
}

/**
 * @summary Remove Owner Portal Access
 */
export const removeOwnerPortalAccess = async (ownerId: number, options?: Parameters<typeof apiFetch>[1]): Promise<removeOwnerPortalAccessResponse> => {

  return apiFetch<removeOwnerPortalAccessResponse>(getRemoveOwnerPortalAccessUrl(ownerId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveOwnerPortalAccessMutationKey = () => ['removeOwnerPortalAccess'] as const;

export const getRemoveOwnerPortalAccessMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOwnerPortalAccess>>, TError,RemoveOwnerPortalAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOwnerPortalAccess>>, TError,RemoveOwnerPortalAccessMutationVariables, TContext> => {

const mutationKey = getRemoveOwnerPortalAccessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOwnerPortalAccess>>, RemoveOwnerPortalAccessMutationVariables> = (props) => {
          const {ownerId} = props ?? {};

          return  removeOwnerPortalAccess(ownerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOwnerPortalAccessMutationResult = NonNullable<Awaited<ReturnType<typeof removeOwnerPortalAccess>>>

    export type RemoveOwnerPortalAccessMutationError = HTTPValidationError
    export type RemoveOwnerPortalAccessMutationVariables = {ownerId: number}

    /**
 * @summary Remove Owner Portal Access
 */
export const useRemoveOwnerPortalAccess = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOwnerPortalAccess>>, TError,RemoveOwnerPortalAccessMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeOwnerPortalAccess>>,
        TError,
        RemoveOwnerPortalAccessMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveOwnerPortalAccessMutationOptions(options), queryClient);
    }
    export type listOwnersResponse200 = {
  data: PaginatedOwnerListOut
  status: 200
}

export type listOwnersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listOwnersResponseSuccess = (listOwnersResponse200) & {
  headers: Headers;
};
export type listOwnersResponseError = (listOwnersResponse422) & {
  headers: Headers;
};

export type listOwnersResponse = (listOwnersResponseSuccess | listOwnersResponseError)

export const getListOwnersUrl = (params?: ListOwnersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/owners?${stringifiedParams}` : `/api/owners`
}

/**
 * @summary List Owners
 */
export const listOwners = async (params?: ListOwnersParams, options?: Parameters<typeof apiFetch>[1]): Promise<listOwnersResponse> => {

  return apiFetch<listOwnersResponse>(getListOwnersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnersQueryKey = (params?: ListOwnersParams,) => {
    return [
    `/api/owners`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOwnersQueryOptions = <TData = Awaited<ReturnType<typeof listOwners>>, TError = HTTPValidationError>(params?: ListOwnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwners>>> = ({ signal }) => listOwners(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnersQueryResult = NonNullable<Awaited<ReturnType<typeof listOwners>>>
export type ListOwnersQueryError = HTTPValidationError


export function useListOwners<TData = Awaited<ReturnType<typeof listOwners>>, TError = HTTPValidationError>(
 params: undefined |  ListOwnersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwners>>,
          TError,
          Awaited<ReturnType<typeof listOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwners<TData = Awaited<ReturnType<typeof listOwners>>, TError = HTTPValidationError>(
 params?: ListOwnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwners>>,
          TError,
          Awaited<ReturnType<typeof listOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwners<TData = Awaited<ReturnType<typeof listOwners>>, TError = HTTPValidationError>(
 params?: ListOwnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Owners
 */

export function useListOwners<TData = Awaited<ReturnType<typeof listOwners>>, TError = HTTPValidationError>(
 params?: ListOwnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createOwnerResponse201 = {
  data: OwnerOut
  status: 201
}

export type createOwnerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createOwnerResponseSuccess = (createOwnerResponse201) & {
  headers: Headers;
};
export type createOwnerResponseError = (createOwnerResponse422) & {
  headers: Headers;
};

export type createOwnerResponse = (createOwnerResponseSuccess | createOwnerResponseError)

export const getCreateOwnerUrl = () => {




  return `/api/owners`
}

/**
 * @summary Create Owner
 */
export const createOwner = async (ownerIn: OwnerIn, options?: Parameters<typeof apiFetch>[1]): Promise<createOwnerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createOwnerResponse>(getCreateOwnerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ownerIn)
  }
);}





export const getCreateOwnerMutationKey = () => ['createOwner'] as const;

export const getCreateOwnerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwner>>, TError,CreateOwnerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOwner>>, TError,CreateOwnerMutationVariables, TContext> => {

const mutationKey = getCreateOwnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwner>>, CreateOwnerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOwner(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof createOwner>>>
    export type CreateOwnerMutationBody = OwnerIn
    export type CreateOwnerMutationError = HTTPValidationError
    export type CreateOwnerMutationVariables = {data: OwnerIn}

    /**
 * @summary Create Owner
 */
export const useCreateOwner = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwner>>, TError,CreateOwnerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOwner>>,
        TError,
        CreateOwnerMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOwnerMutationOptions(options), queryClient);
    }
    export type getOwnerResponse200 = {
  data: OwnerOut
  status: 200
}

export type getOwnerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getOwnerResponseSuccess = (getOwnerResponse200) & {
  headers: Headers;
};
export type getOwnerResponseError = (getOwnerResponse422) & {
  headers: Headers;
};

export type getOwnerResponse = (getOwnerResponseSuccess | getOwnerResponseError)

export const getGetOwnerUrl = (recordId: number,) => {




  return `/api/owners/${recordId}`
}

/**
 * @summary Get Owner
 */
export const getOwner = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getOwnerResponse> => {

  return apiFetch<getOwnerResponse>(getGetOwnerUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnerQueryKey = (recordId: number,) => {
    return [
    `/api/owners/${recordId}`
    ] as const;
    }


export const getGetOwnerQueryOptions = <TData = Awaited<ReturnType<typeof getOwner>>, TError = HTTPValidationError>(recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwner>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnerQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwner>>> = ({ signal }) => getOwner(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnerQueryResult = NonNullable<Awaited<ReturnType<typeof getOwner>>>
export type GetOwnerQueryError = HTTPValidationError


export function useGetOwner<TData = Awaited<ReturnType<typeof getOwner>>, TError = HTTPValidationError>(
 recordId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwner>>,
          TError,
          Awaited<ReturnType<typeof getOwner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwner<TData = Awaited<ReturnType<typeof getOwner>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwner>>,
          TError,
          Awaited<ReturnType<typeof getOwner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwner<TData = Awaited<ReturnType<typeof getOwner>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwner>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Owner
 */

export function useGetOwner<TData = Awaited<ReturnType<typeof getOwner>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwner>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnerQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateOwnerResponse200 = {
  data: OwnerOut
  status: 200
}

export type updateOwnerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateOwnerResponseSuccess = (updateOwnerResponse200) & {
  headers: Headers;
};
export type updateOwnerResponseError = (updateOwnerResponse422) & {
  headers: Headers;
};

export type updateOwnerResponse = (updateOwnerResponseSuccess | updateOwnerResponseError)

export const getUpdateOwnerUrl = (recordId: number,) => {




  return `/api/owners/${recordId}`
}

/**
 * @summary Update Owner
 */
export const updateOwner = async (recordId: number,
    ownerIn: OwnerIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateOwnerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateOwnerResponse>(getUpdateOwnerUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ownerIn)
  }
);}





export const getUpdateOwnerMutationKey = () => ['updateOwner'] as const;

export const getUpdateOwnerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwner>>, TError,UpdateOwnerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOwner>>, TError,UpdateOwnerMutationVariables, TContext> => {

const mutationKey = getUpdateOwnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOwner>>, UpdateOwnerMutationVariables> = (props) => {
          const {recordId,data} = props ?? {};

          return  updateOwner(recordId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof updateOwner>>>
    export type UpdateOwnerMutationBody = OwnerIn
    export type UpdateOwnerMutationError = HTTPValidationError
    export type UpdateOwnerMutationVariables = {recordId: number;data: OwnerIn}

    /**
 * @summary Update Owner
 */
export const useUpdateOwner = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOwner>>, TError,UpdateOwnerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOwner>>,
        TError,
        UpdateOwnerMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOwnerMutationOptions(options), queryClient);
    }
    export type deleteOwnerResponse204 = {
  data: void
  status: 204
}

export type deleteOwnerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteOwnerResponseSuccess = (deleteOwnerResponse204) & {
  headers: Headers;
};
export type deleteOwnerResponseError = (deleteOwnerResponse422) & {
  headers: Headers;
};

export type deleteOwnerResponse = (deleteOwnerResponseSuccess | deleteOwnerResponseError)

export const getDeleteOwnerUrl = (recordId: number,) => {




  return `/api/owners/${recordId}`
}

/**
 * @summary Delete Owner
 */
export const deleteOwner = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteOwnerResponse> => {

  return apiFetch<deleteOwnerResponse>(getDeleteOwnerUrl(recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOwnerMutationKey = () => ['deleteOwner'] as const;

export const getDeleteOwnerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwner>>, TError,DeleteOwnerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOwner>>, TError,DeleteOwnerMutationVariables, TContext> => {

const mutationKey = getDeleteOwnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOwner>>, DeleteOwnerMutationVariables> = (props) => {
          const {recordId} = props ?? {};

          return  deleteOwner(recordId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOwner>>>

    export type DeleteOwnerMutationError = HTTPValidationError
    export type DeleteOwnerMutationVariables = {recordId: number}

    /**
 * @summary Delete Owner
 */
export const useDeleteOwner = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwner>>, TError,DeleteOwnerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOwner>>,
        TError,
        DeleteOwnerMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOwnerMutationOptions(options), queryClient);
    }
